const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchFlashcardSet = async (setId) => {
  try {
    if (!API_BASE_URL) {
      throw new Error('API configuration missing. Please check environment variables.');
    }
    const url = `${API_BASE_URL}?file=flashcards_${setId}.json`;
    
    const response = await fetch(url, {
      method: 'GET',
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Flashcard set not found');
      } else if (response.status === 403) {
        throw new Error('Access denied');
      } else if (response.status >= 500) {
        throw new Error('Server error - please try again later');
      } else {
        throw new Error(`Failed to load flashcard set (${response.status})`);
      }
    }

    const data = await response.json();
    
    if (!Array.isArray(data)) {
      throw new Error('Invalid flashcard data format');
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching flashcard set:', error);
    throw error;
  }
};

export const fetchAvailableSets = async () => {
  try {
    const availableSets = [
      { id: '1', name: 'Security+ Set 1', description: 'Basic Security Concepts' },
      { id: '2', name: 'Security+ Set 2', description: 'Network Security' },
      { id: '3', name: 'Security+ Set 3', description: 'Risk Management' }
    ];
    
    return availableSets;
  } catch (error) {
    console.error('Error fetching available sets:', error);
    throw error;
  }
};